import * as XLSX from "xlsx";
import { getFieldsOrganization, getFieldsTicketByForm, getFieldsUser, getTicketForms } from "../../service/ticket";
import { FormsType, SpreadSheetProps } from "./spreadsheetType";
import { useState } from "react";
import { getMetaData, getZendeskUrl } from "../../service/zendesk";


export function useSpreadSheet({ type = 'ticket' }: SpreadSheetProps) {
    const [openModal, setOpenModal] = useState<boolean>(false)
    const [forms, setForms] = useState<FormsType[]>([]);
    const [selectedForm, setSelectedForm] = useState<number | null>(null);


    const getParams = async () => {
        const metadata = await getMetaData();
        const email = metadata.emailAdmin;
        const token = metadata.apiToken;
        const subdomain = getZendeskUrl();

        return { email, token, subdomain }
    }

    const openCustomModal = async () => {
        const params = await getParams()
        setOpenModal(true);
        const formsData = await getTicketForms(params);
        setForms(formsData);
    };

    const fetchFieldsTicket = async () => {
        const params = await getParams()

        const response = await getFieldsTicketByForm(selectedForm, params);

        const headers = [
            "ticket_form",
            ...response.base_fields,
            ...response.custom_fields.map(
                (f: any) => f.title
            )
        ];
        return headers
    }

    const fetchFields = async () => {
        let res: string[] = [];

        const params = await getParams()

        if (type === "user") {
            const camposAdicionais = ["name", "email", "role"];
            const result = await getFieldsUser(params);

            const keys = result.map((f: any) => f.key);

            res = [...camposAdicionais, ...keys];
        }

        if (type === "organization") {
            const camposAdicionais = ["name"];
            const result = await getFieldsOrganization(params);

            const keys = result.map((f: any) => f.key);

            res = [...camposAdicionais, ...keys];
        }

        return res;
    };

    const titles_files = {
        "ticket": "fields_ticket_zendesk.xlsx",
        "user": "fields_user_zendesk.xlsx",
        "organization": "fields_organization_zendesk.xlsx"
    }

    const downloadSpreadsheet = async () => {
        const fieldsFromAPI = type === "ticket" ? await fetchFieldsTicket() : await fetchFields();

        const data: any[] = type === "ticket" && selectedForm
            ? [{ ticket_form: selectedForm }]
            : [];

        const ws = XLSX.utils.json_to_sheet(data, { header: fieldsFromAPI });

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, `Campos do ${type}`);

        XLSX.writeFile(wb, titles_files[type]);
    };

    return { downloadSpreadsheet, openModal, openCustomModal, forms, setOpenModal, setSelectedForm, selectedForm, };
}
